export const DATE_FORMATS = {
    DD_MM           : 'DD/MM',
    H_MM_A_Z        : 'h:mm A z',
    DD_MM_HH_MM_A_Z : 'DD/MM - hh:mm A z'
}



// WEBPACK FOOTER //
// ../app/constants/dateFormats.js